import { render, staticRenderFns } from "./OrderManagementDashboard.vue?vue&type=template&id=729b8c16"
import script from "./OrderManagementDashboard.vue?vue&type=script&lang=js"
export * from "./OrderManagementDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports